<mat-card>
  <app-card-header
    [title]="title"
    icono="route"
    [draggable]="false"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Content -->
      <mat-card-content
        [class.cardContentFullscreen]="true"
        class="card-content-crear"
      >
        <!-- Datos Básicos -->
        <app-content-card title="Datos Básicos" icon="info" color="blue">
          <section class="inputs-group">
            <div style="width: 50%">
              <mat-form-field style="width: 100%">
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="nombre" />
                <mat-icon matPrefix>label</mat-icon>
              </mat-form-field>
            </div>
            <div style="width: 50%">
              <mat-form-field style="width: 100%">
                <mat-label>Color</mat-label>
                <input matInput readonly formControlName="color" />
                <ngx-colors
                  class="suffix"
                  matSuffix
                  ngx-colors-trigger
                  formControlName="color"
                ></ngx-colors>
              </mat-form-field>
            </div>
          </section>
        </app-content-card>

        <!-- Flota (en vehículos las agrupaciones son flotas; "línea" es de
             colectivos) -->
        <app-content-card title="Flota" icon="workspaces" color="green">
          <section class="inputs-group">
            <div style="width: 100%; display: flex; gap: 8px">
              <ng-select
                [fixedPlaceholder]="true"
                [items]="grupos"
                bindLabel="nombre"
                bindValue="_id"
                formControlName="idGrupo"
                placeholder="Flota"
                style="flex: 1"
                appendTo="body"
              ></ng-select>
              <app-button
                matType="mat-fab"
                color="primary"
                icon="add"
                [tooltip]="'Crear flota'"
                (click)="crearGrupo()"
              ></app-button>
            </div>
          </section>
        </app-content-card>

        <!-- Importar Recorrido -->
        <app-content-card
          title="Importar Recorrido desde Vehículo"
          icon="upload"
          color="orange"
        >
          <section
            style="
              display: flex;
              flex-direction: column;
              gap: 8px;
              padding: 12px;
            "
          >
            <small style="color: gray">
              Seleccioná un vehículo y fecha para importar un recorrido real
            </small>

            <ng-select
              [items]="vehiculos"
              [(ngModel)]="vehiculo"
              [ngModelOptions]="{ standalone: true }"
              bindLabel="identificacion"
              placeholder="Vehículo"
              [notFoundText]="'No hay Vehículos'"
              [multiple]="false"
              [searchable]="true"
              appendTo="body"
            ></ng-select>

            <div style="display: flex; gap: 8px; align-items: center">
              <div style="flex: 1">
                <app-date-range-selector
                  [(dateRange)]="range"
                  [maxDate]="fechaActual"
                  [placeholder]="'Fecha'"
                  [selectMode]="'single'"
                  tooltip="La fecha se busca con ±12 horas a lo seleccionado"
                ></app-date-range-selector>
              </div>

              <app-button
                matType="mat-mini-fab"
                color="primary"
                (click)="buscar()"
                [icon]="'search'"
                [disabled]="!canBuscar"
                tooltip="Buscar recorridos"
              ></app-button>

              <app-button
                matType="mat-mini-fab"
                color="neutral"
                (click)="resetearImportacion()"
                [icon]="'clear'"
                tooltip="Limpiar"
              ></app-button>
            </div>

            <div style="max-height: 300px; overflow: auto; margin-top: 4px">
              @for (inter of interaccionesBusqueda; track inter) {
                <mat-expansion-panel
                  hideToggle
                  [expanded]="interaccionesBusquedaSelected === inter"
                  [ngClass]="
                    interaccionesBusquedaSelected === inter ? 'ac-85' : ''
                  "
                  (expandedChange)="onRecorridoSelected(inter, $event)"
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @if (inter.startTime !== inter.endTime) {
                        {{ inter.startTime | date: 'short' }} >>>
                        {{ inter.endTime | date: 'HH:mm' }}
                      } @else {
                        {{ inter.startTime | date: 'short' }}
                      }

                      @if (
                        loadingReportes &&
                        interaccionesBusquedaSelected === inter
                      ) {
                        <mat-spinner
                          diameter="20"
                          color="primary"
                        ></mat-spinner>
                      }
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                </mat-expansion-panel>
              }
            </div>

            @if (buscando) {
              <div
                style="
                  height: 200px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-top: 16px;
                "
              >
                <mat-progress-spinner
                  color="primary"
                  mode="indeterminate"
                ></mat-progress-spinner>
              </div>
            }
          </section>
        </app-content-card>

        <!-- Cumplimiento -->
        <app-content-card
          title="Cumplimiento del Recorrido"
          icon="checklist"
          color="teal"
        >
          <section [formGroup]="cumplimientoForm" class="cumplimiento">
            <!-- Interruptor maestro -->
            <div class="cumplimiento-master">
              <mat-slide-toggle formControlName="activo">
                Medir el cumplimiento de este recorrido
              </mat-slide-toggle>
              <p class="cumplimiento-master-texto">
                Compara los reportes del vehículo asignado contra esta traza y
                calcula qué porcentaje del recorrido hace realmente.
              </p>
            </div>

            @if (mideCumplimiento) {
              <!-- Resumen de la traza -->
              @if (geometria) {
                <div class="cumplimiento-metricas">
                  <div class="metrica">
                    <span class="metrica-valor">
                      {{ geometria.longitudMetros / 1000 | number: '1.2-2' }}
                      <em>km</em>
                    </span>
                    <span class="metrica-label">Largo de la traza</span>
                  </div>
                  <div class="metrica">
                    <span class="metrica-valor">
                      {{ geometria.cantidadBuckets }}
                    </span>
                    <span class="metrica-label">
                      Tramos de {{ geometria.largoBucketMetros }} m
                    </span>
                  </div>
                  <div class="metrica">
                    <span class="metrica-valor">
                      {{ 100 / geometria.cantidadBuckets | number: '1.1-1' }}
                      <em>%</em>
                    </span>
                    <span class="metrica-label">Aporta cada tramo</span>
                  </div>
                </div>
              } @else {
                <div class="cumplimiento-nota">
                  <mat-icon>info</mat-icon>
                  <span>Los tramos se calculan al guardar el recorrido.</span>
                </div>
              }

              <!-- Criterios de aprobación -->
              <div class="cumplimiento-bloque">
                <h4>Criterios de aprobación</h4>

                <div class="cumplimiento-toggles">
                  <mat-slide-toggle formControlName="porCobertura">
                    Exigir cobertura de la traza
                  </mat-slide-toggle>
                  <mat-slide-toggle formControlName="porTiempo">
                    Exigir hacerlo en el tiempo esperado
                  </mat-slide-toggle>
                </div>

                <div class="cumplimiento-campos">
                  <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Tolerancia a la traza</mat-label>
                    <input
                      matInput
                      type="number"
                      min="5"
                      max="500"
                      formControlName="toleranciaMetros"
                    />
                    <span matTextSuffix>m</span>
                    @if (cumplimientoForm.get('toleranciaMetros')?.invalid) {
                      <mat-error>Tiene que estar entre 5 y 500 m</mat-error>
                    } @else {
                      <mat-hint>30-40 m urbano, 80-120 m ruta</mat-hint>
                    }
                  </mat-form-field>

                  <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Cobertura mínima para aprobar</mat-label>
                    <input
                      matInput
                      type="number"
                      min="1"
                      max="100"
                      formControlName="minimoPorcentaje"
                    />
                    <span matTextSuffix>%</span>
                    @if (cumplimientoForm.get('minimoPorcentaje')?.invalid) {
                      <mat-error>Tiene que estar entre 1 y 100</mat-error>
                    } @else {
                      <mat-hint>Desde acá se da por completado</mat-hint>
                    }
                  </mat-form-field>

                  @if (cumplimientoForm.get('porTiempo')?.value) {
                    <!-- `duracion` es un campo del recorrido, no del subgrupo de
                         cumplimiento: se bindea por control para no anidar
                         formGroups. -->
                    <mat-form-field subscriptSizing="dynamic">
                      <mat-label>Duración esperada</mat-label>
                      <input
                        matInput
                        type="number"
                        min="1"
                        max="1440"
                        [formControl]="duracionControl"
                      />
                      <span matTextSuffix>min</span>
                      @if (duracionControl?.invalid) {
                        <mat-error>
                          Tiene que estar entre 1 y 1440 min
                        </mat-error>
                      } @else {
                        <mat-hint>Para el recorrido completo</mat-hint>
                      }
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic">
                      <mat-label>Tolerancia de tiempo</mat-label>
                      <input
                        matInput
                        type="number"
                        min="0"
                        max="200"
                        formControlName="toleranciaTiempoPorcentaje"
                      />
                      <span matTextSuffix>%</span>
                      @if (
                        cumplimientoForm.get('toleranciaTiempoPorcentaje')
                          ?.invalid
                      ) {
                        <mat-error>Tiene que estar entre 0 y 200</mat-error>
                      } @else {
                        <mat-hint>Margen sobre la duración esperada</mat-hint>
                      }
                    </mat-form-field>
                  }
                </div>
              </div>

              <!-- Comportamiento de la medición -->
              <div class="cumplimiento-bloque">
                <h4>Cómo se mide</h4>

                <div class="cumplimiento-toggles">
                  <mat-slide-toggle formControlName="esCiclico">
                    Recorrido cíclico (mide por vuelta)
                  </mat-slide-toggle>
                  <mat-slide-toggle formControlName="respetarOrden">
                    Respetar el sentido de la traza
                  </mat-slide-toggle>
                  <mat-slide-toggle formControlName="inicioEstricto">
                    Arrancar sólo al llegar al inicio
                  </mat-slide-toggle>
                </div>

                @if (sugiereCiclico) {
                  <div class="cumplimiento-nota advertencia">
                    <mat-icon>loop</mat-icon>
                    <span>
                      La traza vuelve al punto de partida: probablemente
                      convenga marcarla como cíclica para medir por vuelta.
                    </span>
                  </div>
                }

                <div class="cumplimiento-campos">
                  <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Cerrar la medición sin reportes</mat-label>
                    <input
                      matInput
                      type="number"
                      min="1"
                      max="1440"
                      formControlName="timeoutMinutos"
                    />
                    <span matTextSuffix>min</span>
                    @if (cumplimientoForm.get('timeoutMinutos')?.invalid) {
                      <mat-error>Tiene que estar entre 1 y 1440 min</mat-error>
                    } @else {
                      <mat-hint>Minutos sin reportes sobre la traza</mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>
            }
          </section>
        </app-content-card>

        <!-- Recorrido -->
        <app-content-card title="Recorrido" icon="map" color="purple">
          <!-- Ajuste a las calles. Se ofrece como acción explícita y no automática
               porque OSRM elige la mejor ruta entre los vértices, que puede no ser
               la que se dibujó (y hay trazas que van por caminos que no están en
               la red vial). -->
          <section class="ajuste-traza">
            <div class="ajuste-acciones">
              <app-button
                matType="mat-raised-button"
                color="primary"
                icon="alt_route"
                text="Ajustar a las calles"
                [disabled]="!puedeAjustarACalles"
                [loading]="ajustando"
                tooltip="Reemplaza la traza dibujada por la ruta que sigue las calles entre sus puntos"
                (click)="ajustarACalles()"
              ></app-button>

              @if (puedeDeshacerAjuste) {
                <app-button
                  matType="mat-raised-button"
                  color="neutral"
                  icon="undo"
                  text="Deshacer ajuste"
                  (click)="deshacerAjuste()"
                ></app-button>
              }
            </div>
            <small>
              Dibujá la traza con puntos cada pocos kilómetros y después
              ajustala: queda pegada al camino real, que es contra lo que se
              mide el cumplimiento. Una traza de pocos puntos sobre un camino
              con curvas deja tramos rectos a cientos de metros del asfalto.
            </small>
          </section>

          <div class="mapa-embebido-wrapper">
            <app-map-draw-mapbox
              [form]="geojson"
              tipo="LineString"
              [color]="
                form.get('color')?.value ||
                clientePropio?.config?.tema?.primaryColor
              "
            ></app-map-draw-mapbox>
          </div>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="volver()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
